import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useParams } from "react-router-dom";
import { useWeb3React } from "@web3-react/core";
import { ethers } from "ethers";

import abiERC721 from "../../constants/sourceContract/abi/abiERC721.json";
import abiERC1155 from "../../constants/sourceContract/abi/abiERC1155.json";

import { Field, Form, Formik } from "formik";
import * as yup from "yup";

import toast from "react-hot-toast";
import Tooltip from "@mui/material/Tooltip";

import Typography from "@mui/material/Typography";
import Input from "@mui/material/Input";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { styled } from "@mui/material";

import {
	Card,
	CardBody,
	Row,
	Col,
	Button,
	Input as InputStrap,
	Label,
} from "reactstrap";
import {
	getCopyUploadLink,
	getUploadLink,
	pinFileIPFS,
	pinJSONIPFS,
	updataUnlock,
	useCloneToken,
} from "../../hooks";
import {
	tmpDelete,
	tmpUpload,
	ACTION_UPLOAD_TMP_DELETE,
	ACTION_UPLOAD_LOCK_DELETE,
	ACTION_UPLOAD_COVER_DELETE,
} from "../../store/actions/tmpUpload";
import { saveToken, setTokens } from "../../store/actions/token";

import MintModal from "./MintModal";
import PreviewModal from "./PreviewModal";
import CircularUploader from "../common/CircularUploader";
import iconVideo from "../../assets/img/video-icon.jpg";
import iconAudio from "../../assets/img/mp3-icon.jpg";

import { formatEther } from "ethers/lib/utils";
import { ethersToBN, getContractAbi, getFileTypeMime } from "../../utils";
import BatchMintComponent from "./BatchMint";
import PrewiewToken from "./PrewiewToken";
import CreateAtribute from "./CreateAtribute";
import LockableCreator from "./LockableCreator";
import ConfirmMintModal from "./ConfirmMintModal";
import CoverUploader from "../common/CoverUploader";

const styleModal = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	maxWidth: 900,
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 3,
};

export default function MintContract(props) {
	const INIT = useMemo(() => {
		return {
			price: 0,
			digitalKey: { value: "", fileName: "", size: null, type: null },
			name: "",
			description: "",
			amount: 1,
			royalties: 0,
			image: "",
			imageType: "",
			cover: "",
			attributes: [{ trait_type: "", value: "" }],
		};
	}, []);

	const { mintAction, tokenId, parentId } = props;
	const { contractID } = useParams();
	const { account, library, chainId } = useWeb3React();
	const dispatch = useDispatch();
	const history = useHistory();
	const { mint } = useCloneToken();
	const tokens = useSelector((state) => state.token.items);

	const getCloneToken = useMemo(
		() => tokens.find((i) => i._id === tokenId),
		[tokens, tokenId]
	);
	const [previewData, setPreviewData] = useState(null);

	const contractList = useSelector((state) => state.contract.items);
	const { batchMint, _id, isOwnPinata, userPinataAPIKey, userPinataAPISecret } =
		useSelector((state) => state.user.user);

	const { user } = useSelector((state) => state.user);

	useEffect(() => {
		if (!!account && !!library) {
			setSigner(library.getSigner());
		}
	}, [account, library, chainId]);

	useEffect(() => {
		let contractId = contractID ?? parentId;
		if (contractId) {
			dispatch(setTokens(_id));
		}
		return () => {
			dispatch({ type: ACTION_UPLOAD_TMP_DELETE });
			dispatch({ type: ACTION_UPLOAD_COVER_DELETE });
			dispatch({ type: ACTION_UPLOAD_LOCK_DELETE });
			setPreviewData({});
			setOwnPinata(false);
		};
	}, [_id, contractID, dispatch, parentId]);

	const [signer, setSigner] = useState(); // signer
	const [contractItem, setContractItem] = useState(null);
	const [totalMintTokens, setTotalMintTokens] = useState(null);

	const [isBatchMint, setIsBatchMint] = useState(false); // Switch batch minting
	const [ownPinata, setOwnPinata] = useState(false); // Switch use own Pinata credantial

	const [currency, setCurrency] = useState("eth"); // currency
	const [open, setOpen] = useState(false); // select currency

	const [lockableToIPFS, setLockableToIPFS] = useState(false); // Lockable file to IPFS storage',
	const [showLockablePreview, setShowLockablePreview] = useState(false); // Lockable modal preview

	const sizeLimit = 100 * 1024; // Limit for size upload file, Kb
	const spacesURL = process.env.REACT_APP_API_DO_URL;
	const imageIpfsURL = `${process.env.REACT_APP_IPFS_HOST}/`;

	const [show, setShow] = useState(false);
	const [stage, setStage] = useState("none");
	const [error, setError] = useState(null);
	const [openClonModal, setOpenClonModal] = useState(true);
	const [maxTokensLimit, setMaxTokensLimit] = useState(0);
	const [availableToMintTokens, setAvailableToMintTokens] = useState(0);

	const [openActionModal, setOpeActionnModal] = useState(false);
	const handleCloseActionModal = () => {
		setOpeActionnModal(false);
	};

	const { image, cover, lockable, tempIsUploading, lockableIsUploading } =
		useSelector((state) => state.tmpUpload);

	useEffect(() => {
		if (contractItem) {
			if (["ERC721A", "ERC721PSI"].includes(contractItem.type)) {
				setIsBatchMint(true);
			}
		}
	}, [contractItem]);

	useEffect(() => {
		if (contractList.length > 0) {
			setContractItem(
				contractList.find(
					(item) => item._id === contractID || item._id === parentId
				)
			);
		}
		if (tokens.length > 0) {
			setTotalMintTokens(
				tokens.filter(
					(i) => i.contractId === contractID || i.contractId === parentId
				)
			);
		}
	}, [tokenId, contractList, tokens, contractID, parentId]);

	useEffect(() => {
		if (contractItem) {
			setPreviewData(contractID ? INIT : getCloneToken);
		}
	}, [contractItem, tokens, contractID, getCloneToken, INIT]);

	const userSchema = yup.object().shape({
		price: yup.number("Enter number"),
		name: yup.string().required("Name is required"),
		description: yup.string(),
		amount: yup.number().min(1).required("Enter amount > 0"),
		royalties: yup.number().max(100, "Maximum is 100%").min(0, "Minimum is 0%"),
	});

	const hideModal = () =>
		new Promise((resolve) => {
			setTimeout(() => {
				setShow(false);
				setStage("none");
				setError(null);
				resolve();
			}, 3000);
		});

	const closeButton = () => {
		if (image?.name) {
			dispatch(tmpDelete(image.name));
		}
		if (cover?.name) {
			dispatch(tmpDelete(cover.name, "cover"));
		}
		setPreviewData({
			...previewData,
			image: null,
			imageType: null,
			thumbnail: "",
			cover: "",
		});
	};
	const handleChange = (event) => {
		if (event.target.name === "currency") {
			setCurrency(event.target.value);
		} else if (event.target.name === "isBatch") {
			setIsBatchMint(
				["ERC721A", "ERC721PSI"].includes(contractItem?.type)
					? true
					: event.target.checked
			);
			closeButton();
		} else if (event.target.name === "isOwnPinata") {
			setOwnPinata(event.target.checked);
		}
	};
	const handleBlure = (event) => {
		const { name, value } = event.target;
		setPreviewData({ ...previewData, [name]: value });
	};

	const handleClose = () => {
		setOpen(false);
	};

	const handleOpen = () => {
		setOpen(true);
	};
	const handlAddButton = () => {
		setPreviewData({
			...previewData,
			attributes: [
				...previewData.attributes,
				{
					trait_type: "",
					value: "",
				},
			],
		});
	};

	const updateNftStuff = useCallback(() => {
		if (
			["ERC721", "ERC721A", "ERC721PSI", "ERC1155"].includes(contractItem?.type)
		) {
			const contract_ = new ethers.Contract(
				contractItem.address,
				getContractAbi(contractItem.type),
				!!library ? library.getSigner() : library
			);

			if (contract_["MAX_SUPPLY()"]) {
				contract_.MAX_SUPPLY().then((maxSupplyBN) => {
					const maxSupplyFormatted = ethersToBN(maxSupplyBN).toNumber();

					setMaxTokensLimit(maxSupplyFormatted);
				});
			}
		}
	}, [contractItem, library]);

	useEffect(() => {
		updateNftStuff();
	}, [updateNftStuff]);

	const InputAsset = styled("input")({
		display: "none",
	});

	const uploadAsset = (event) => {
		let file = event.target.files[0];
		const fileType = getFileTypeMime(file.type, file.name);
		const fileSize = Math.round(file.size / 1024); // kilobyte

		if (!!file) {
			if (fileSize > sizeLimit) {
				toast.error(
					`File size ${fileSize}Kb,  need no more ${Math.round(
						sizeLimit / 1024
					)}Mb`
				);
				if (fileType === "unknowtype") {
					toast.error(`This file type is not supported`);
				}
			} else if (fileType !== "unknowtype") {
				dispatch(tmpUpload(file));
			} else {
				toast.error(`This file type is not supported`);
			}
		}
	};

	const onFormSubmit = async (data) => {
		if (!image?.name && !previewData.image) {
			return toast.error("Need add Token's image!");
		}
		if (
			((image?.name && !image?.type.includes("image/")) ||
				(previewData.image && !previewData.imageType.includes("image/"))) &&
			!previewData.cover
		) {
			return toast.error("Need add Token's cover!");
		}
		setShow(true);
		setStage("upload");

		data.digitalKey = previewData.digitalKey;
		data.attributes = previewData.attributes;

		let metadata = { ...data };
		delete metadata.price;

		async function lockableCreate() {
			let digitalKey;
			if (!lockableToIPFS) {
				digitalKey = process.env.REACT_APP_API_DO_URL + lockable.name;
			} else {
				const data = await pinFileIPFS(
					lockable.name,
					"",
					!ownPinata,
					"upload",
					ownPinata ? _id : "main"
				);
				digitalKey =
					ownPinata && user?.userPinataDomen
						? user?.userPinataDomen + data.imageHash
						: `ipfs://ipfs/${ownPinata ? data.imageHash : data}`;
			}
			return digitalKey;
		}

		let unlockID;
		async function hashCreator(jsonData) {
			console.log("executing hashCreator...");
			let imageHash, coverHash, thumbnail;
			if (image.name) {
				let data = await pinFileIPFS(
					image.name,
					jsonData.cover ?? "",
					null,
					"tmp",
					ownPinata ? _id : "main"
				);
				imageHash = data.imageHash;
				coverHash = data.coverHash;
				thumbnail = data.thumbnail;
			} else if (cover.name) {
				imageHash = previewData.image;
				let data = await pinFileIPFS(
					cover.name,
					true,
					null,
					"tmp",
					ownPinata ? _id : "main"
				);
				coverHash = data.imageHash;
				thumbnail = data.thumbnail;
			} else {
				imageHash = previewData.image;
				coverHash = previewData.cover;
				thumbnail = previewData.thumbnail;
			}

			if (coverHash) {
				jsonData.image = "ipfs://ipfs/" + coverHash;
				jsonData.animation_url = "ipfs://ipfs/" + imageHash;
			} else {
				jsonData.image = "ipfs://ipfs/" + imageHash;
			}
			data.image = imageHash;
			data.cover = coverHash;
			data.thumbnail = thumbnail;

			delete jsonData.cover;

			console.log("still executing?");
			console.log("jsonData", jsonData);

			if (image.type) {
				data.imageType = image.type;
			} else {
				data.imageType = previewData.imageType;
			}

			if (jsonData.digitalKey.value || jsonData.digitalKey.fileName) {
				if (lockable.name) {
					const digitalKey = await lockableCreate();
					// console.log(
					// 	"🚀 ~ file: MintContract.js ~ line 385 ~ hashCreator ~ digitalKey",
					// 	digitalKey
					// );
					jsonData.digitalKey.value = digitalKey; // why?
					data.digitalKey.value = digitalKey;
				}
				const params = {
					account,
					digitalKey: jsonData.digitalKey.value,
					fileName: !lockableToIPFS ? lockable?.name : "",
					contentType: lockable?.type,
				};
				const { _id, addPath } =
					lockable.name ||
					(previewData.digitalKey.value && !previewData.digitalKey.size)
						? await getUploadLink(params)
						: await getCopyUploadLink(jsonData.unlockableLink);
				data.unlockableLink = addPath;
				jsonData.external_url = `${process.env.REACT_APP_API_UNLOCK}/${addPath}`;
				unlockID = _id;
			} else {
				delete data.unlockableLink;
			}
			delete jsonData.digitalKey;
			delete jsonData.unlockableLink;
			delete jsonData.imageType;
			if (!contractID) {
				delete jsonData.contractId;
				delete jsonData.unlockableLink;
				delete jsonData.burnt;
				delete jsonData.burntGas;
				delete jsonData.dataCreate;
				delete jsonData.gas;
				delete jsonData.metadataLink;
				delete jsonData.tokenID;
				delete jsonData.transferGas;
				delete jsonData._id;
				delete jsonData.__v;
			}
			let hashMeta = await pinJSONIPFS(jsonData);
			return hashMeta;
		}

		try {
			const hashMetaToken = await hashCreator(metadata);

			data.metadataLink = hashMetaToken;
			// console.log(
			// 	"🚀 ~ file: MintContract.js ~ line 432 ~ onFormSubmit ~ data",
			// 	data
			// );

			if (!contractID) {
				delete data._id;
				delete data.burnt;
				delete data.burntGas;
				delete data.burntGas;
				delete data.dataCreate;
				delete data.gas;
				delete data.tokenID;
				delete data.transferGas;
			}

			let tokenResponce;
			if (contractItem.type === "ERC721" || contractItem.type === "ERC721UPG") {
				const contract = new ethers.Contract(
					contractItem.address,
					abiERC721,
					signer
				);
				setStage("sign");
				tokenResponce = await contract
					.mint(
						hashMetaToken,
						// [],
						// "0x0000000000000000000000000000000000000000000000000000000000000000",
						{ gasLimit: "720000" }
					)
					.catch(() => {
						return null;
					});
				setStage("mint");
			} else if (
				contractItem.type === "ERC1155" ||
				contractItem.type === "ERC1155UPG"
			) {
				const contract = new ethers.Contract(
					contractItem.address,
					abiERC1155,
					signer
				);
				setStage("sign");
				tokenResponce = await contract
					.mint(data.amount, 0, hashMetaToken, { gasLimit: "720000" })
					.catch(() => {
						return null;
					});
				setStage("mint");
			}

			if (tokenResponce === null) {
				await hideModal();
				return;
			}

			data.contractId = contractID ?? parentId;
			setStage("confirm");
			let tokenTxn = await tokenResponce.wait();

			tokenTxn.logs.length > 0 || tokenTxn.events.length > 0
				? setStage("done")
				: setError({ message: "Can`t mint token" });

			let tokenID;
			if (contractItem.type === "ERC721" || contractItem.type === "ERC721UPG") {
				tokenID = await Number.parseInt(tokenTxn.logs[0].topics[3]);
			} else if (
				contractItem.type === "ERC1155" ||
				contractItem.type === "ERC1155UPG"
			) {
				tokenID = await Number.parseInt(tokenTxn.events[1].args.tokenId._hex);
			}

			data.tokenID = tokenID;

			data.gas = (
				tokenTxn.effectiveGasPrice.toNumber() *
				parseFloat(formatEther(tokenTxn.gasUsed._hex))
			).toFixed(8);

			if (data.digitalKey.value) {
				// console.log(
				// 	"🚀 ~ file: MintContract.js ~ line 505 ~ onFormSubmit ~ data.digitalKey",
				// 	data.digitalKey
				// );
				updataUnlock(
					unlockID,
					tokenID,
					contractItem.address,
					contractItem.type
				);
			}
			dispatch(saveToken(data));

			await hideModal();

			history.push(`/contracts/${contractItem._id}`);
		} catch (error) {
			setError({ message: error.message });
			await hideModal();
		} finally {
			if (lockable.name) {
				dispatch(tmpDelete(lockable.name, "lockable"));
			}
			if (image.name) {
				dispatch(tmpDelete(image.name));
			}
			if (cover.name) {
				dispatch(tmpDelete(cover.name, "cover"));
			}
		}
	};

	const closePrev = () => {
		setShowLockablePreview(false);
	};

	const handleCloseClone = () => {
		history.push("/contracts/token/" + tokenId);
	};
	const handleMintClone = () => {
		setOpenClonModal(false);
		const data = {
			previewData,
			setShow,
			setStage,
			setError,
			hideModal,
			contractType: contractItem.type,
			contractAddress: contractItem.address,
		};
		mint(data);
	};

	if (mintAction === "clone") {
		return previewData && contractItem ? (
			<Box>
				<MintModal
					isBatchMint={false}
					show={show}
					stage={stage}
					error={error}
				/>
				<Modal open={mintAction === "clone" && openClonModal} sx={{}}>
					<Box sx={styleModal}>
						<PrewiewToken
							textMaxWidth="100%"
							previewData={previewData}
							contractType={contractItem?.type}
							tempIsUploading={tempIsUploading}
							filePath={`${process.env.REACT_APP_IPFS_HOST}/`}
							fileType={previewData.imageType}
							fileName={previewData.image}
							cover={previewData.cover}
							openLockableModal={setShowLockablePreview}
						/>
						<Box
							sx={{
								display: "flex",
								justifyContent: "space-between",
							}}
						>
							<Button color="primary" onClick={handleMintClone}>
								Create item
							</Button>
							<Button color="primary" onClick={handleCloseClone}>
								Cancel
							</Button>
						</Box>
					</Box>
				</Modal>
			</Box>
		) : (
			<CircularUploader />
		);
	}

	return (
		<>
			{previewData && (
				<Row>
					<Col md={3}>
						{contractItem && (
							<Card className="ecommerce-card" key={contractItem?.name}>
								<CardBody>
									<h4>Contract</h4>
									<div className="item-img text-center mx-auto mb-4">
										<Link to={`/contracts/${contractItem?._id}`}>
											<img
												className="img-fluid card-img-top"
												src={
													contractItem?.image.includes("https://")
														? contractItem?.image
														: `${process.env.REACT_APP_IPFS_HOST}/${contractItem?.image}`
												}
												alt={contractItem?.name}
											/>
										</Link>
									</div>
									<h6 className="item-name">
										<Link
											className="text-body"
											to={`/contracts/${contractItem?._id}`}
										>
											{`${contractItem?.name} (${contractItem?.type})`}
										</Link>
									</h6>
									{maxTokensLimit > 0 && <p>Max limit: {maxTokensLimit}</p>}
									<p>{`Total minted tokens: ${
										totalMintTokens?.length || 0
									}`}</p>
									{maxTokensLimit > 0 && (
										<p>
											Available to mint:{" "}
											{maxTokensLimit - totalMintTokens?.length ?? 0}
										</p>
									)}
								</CardBody>
							</Card>
						)}
					</Col>

					{!isBatchMint && (
						<>
							<Col>
								<Card>
									<CardBody>
										<h1 style={{ textAlign: "center" }}>
											{tokenId ? "Mint token copy" : "Mint token"}
										</h1>
										{contractID && (
											<div className="d-inline-flex justify-content-left align-items-center mb-3">
												<Label
													htmlFor="isBatchMint"
													style={{
														cursor: "pointer",
														fontSize: "14px",
													}}
												>
													Batch minting
												</Label>
												<div className="form-switch mb-2 ps-0">
													<InputStrap
														style={{
															marginLeft: "8px",
															marginTop: 0,
															width: "45px",
															cursor: "pointer",
														}}
														type="switch"
														name="isBatch"
														checked={isBatchMint}
														disabled={!batchMint}
														onChange={handleChange}
														id="isBatchMint"
														aria-label="controlled"
													/>
												</div>
											</div>
										)}

										<Tooltip
											title={
												!userPinataAPIKey || !userPinataAPISecret
													? "Please specify your Pinata API Gateway credentials in your profile to use this feature"
													: ""
											}
										>
											<div>
												{isOwnPinata && (
													<div className="d-flex justify-content-left align-items-center mb-3">
														<Label
															htmlFor="isOwnPinata"
															style={{
																cursor: "pointer",
																fontSize: "14px",
															}}
														>
															Use my Pinata
														</Label>

														<div className="form-switch mb-2 ps-0">
															<InputStrap
																style={{
																	marginLeft: "8px",
																	marginTop: 0,
																	width: "45px",
																	cursor: "pointer",
																}}
																type="switch"
																name="isOwnPinata"
																checked={ownPinata}
																disabled={
																	!userPinataAPIKey || !userPinataAPISecret
																}
																onChange={handleChange}
																id="isOwnPinata"
																aria-label="controlled"
															/>
														</div>
													</div>
												)}
											</div>
										</Tooltip>
										{ownPinata && (
											<Typography
												sx={{
													mb: "2rem",
													letterSpacing: "0.00938em",
													color: "#808080",
													fontFamily: "Montserrat",
													fontSize: "14px",
													lineHeight: "20px",
												}}
											>
												Metadata of your token(s) will be uploaded on IPFS using
												your Pinata API Gateway credentials. To review API
												credentials please go to your profile page
											</Typography>
										)}
										<Formik
											initialValues={previewData}
											enableReinitialize={true}
											validateOnBlur
											validationSchema={userSchema}
											onSubmit={(data) => {
												onFormSubmit(data);
											}}
										>
											<Form>
												<ConfirmMintModal
													open={openActionModal}
													handleClose={handleCloseActionModal}
												/>
												<Typography
													className="form-label"
													sx={{
														fontFamily: "Montserrat",
														fontStyle: "normal",
														fontWeight: "normal",
														fontSize: "17px",
														lineHeight: "24px",
													}}
													variant="p"
												>
													{image.name || previewData?.image
														? "Uploaded file"
														: "Upload file"}
												</Typography>
												<Card
													style={{
														position: "relative",
														display: "flex",
														justifyContent: "center",
														flexWrap: "wrap",
														width: "100%",
														borderRadius: "16px",
														padding: "2rem 3.5rem",
														margin: "2rem 0",
													}}
												>
													<>
														{(image.name || previewData.image) && (
															<Button
																color="primary"
																style={{
																	position: "absolute",
																	top: "0.5rem",
																	right: "0.5rem",
																	width: "40px",
																	minWidth: "40px",
																	height: "40px",
																	border: "1px solid #07ED63",
																	borderRadius: "50%",
																	color: "##040405",
																}}
																onClick={closeButton}
															>
																x
															</Button>
														)}
														{getFileTypeMime(image.type) === "image" ||
														getFileTypeMime(previewData?.imageType) ===
															"image" ? (
															<Box
																sx={{
																	width: "100%",
																	height: "auto",
																}}
																component="img"
																src={
																	image.name
																		? `${spacesURL}/${image.name}`
																		: `${imageIpfsURL}${previewData?.image}`
																}
																alt="upload file"
															/>
														) : getFileTypeMime(image.type) === "audio" ||
														  getFileTypeMime(previewData?.imageType) ===
																"audio" ? (
															<Box
																sx={{
																	width: "100%",
																	height: "auto",
																}}
																component="img"
																src={iconAudio}
																alt="upload file"
															/>
														) : getFileTypeMime(
																previewData?.imageType,
																previewData?.image
														  ) === "3d" ||
														  getFileTypeMime(image.type, image.name) ===
																"3d" ? (
															<Box
																sx={{
																	width: "100%",
																	height: "auto",
																}}
																component="img"
																src={"../../assets/img/3d-icon.jpg"}
																alt="upload file"
															/>
														) : getFileTypeMime(image.type) === "video" ||
														  getFileTypeMime(previewData?.imageType) ===
																"video" ? (
															<Box
																sx={{
																	width: "100%",
																	height: "auto",
																}}
																component="video"
																src={
																	image?.name
																		? `${process.env.REACT_APP_API_DO_URL}/${image.name}`
																		: previewData?.name
																		? `${process.env.REACT_APP_IPFS_HOST}/${previewData?.image}`
																		: ""
																}
																controls
															/>
														) : null}
													</>

													{!image.name && !previewData.image ? (
														<>
															<Typography
																mb="1rem"
																className="form-label"
																sx={{
																	fontFamily: "Montserrat",
																	width: "100%",
																	textAlign: "center",
																}}
																component="p"
															>
																PNG, GIF, WEBP, MP4 or MP3. Max 100mb.
															</Typography>
															<Label
																for="input-image"
																style={{
																	textAlign: "center",
																}}
															>
																<InputAsset
																	accept={
																		"image/*, audio/*,video/*, .glb, .gltf"
																	}
																	id="input-image"
																	type="file"
																	onChange={uploadAsset}
																/>
																<Button
																	color="primary"
																	tag="span"
																	variant="outlined"
																	disabled={tempIsUploading}
																>
																	Choose file
																</Button>
															</Label>
														</>
													) : null}
												</Card>
												{((previewData.imageType &&
													!previewData.imageType.includes("image/")) ||
													(image.type && !image.type.includes("image/"))) && (
													<CoverUploader
														previewData={previewData}
														setPreviewData={setPreviewData}
													/>
												)}
												<Row>
													<Col md={6} xs={12}>
														<Field name="name" type="text">
															{({ field, meta }) => (
																<div
																	style={{
																		minWidth: "20%",
																		marginBottom: "2rem",
																	}}
																>
																	<Label htmlFor="name" className="form-label">
																		Name
																	</Label>
																	<Input
																		{...field}
																		id="name"
																		inputComponent="input"
																		variant="standard"
																		fullWidth
																		onBlur={handleBlure}
																	/>
																	{meta.touched && meta.error && (
																		<div
																			className="field-tip"
																			style={{
																				color: "red",
																			}}
																		>
																			{meta.error}
																		</div>
																	)}
																</div>
															)}
														</Field>
													</Col>
													<Col md={6} xs={12}>
														<Field
															name="price"
															type="text"
															className="input-mint"
														>
															{({ field, meta }) => (
																<div
																	style={{
																		minWidth: "20%",
																		paddingRight: "4rem",
																		marginBottom: "2rem",
																		position: "relative",
																	}}
																>
																	<Label htmlFor="price" className="form-label">
																		Price
																	</Label>
																	<Input
																		{...field}
																		id="price"
																		inputComponent="input"
																		variant="standard"
																		onBlur={handleBlure}
																		fullWidth
																	/>
																	{meta.touched && meta.error && (
																		<div
																			className="field-tip"
																			style={{
																				color: "red",
																			}}
																		>
																			{meta.error}
																		</div>
																	)}

																	<Select
																		open={open}
																		name="currency"
																		readOnly={!contractID}
																		onClose={handleClose}
																		onOpen={handleOpen}
																		value={currency}
																		onChange={handleChange}
																		variant="standard"
																		sx={{
																			position: "absolute",
																			right: "0px",
																		}}
																	>
																		<MenuItem value={"eth"}>ETH</MenuItem>
																		<MenuItem value={"btc"}>BTC</MenuItem>
																	</Select>
																</div>
															)}
														</Field>
													</Col>
													<Col md={6} xs={12}>
														<Field name="description" type="text">
															{({ field, meta }) => (
																<div
																	style={{
																		minWidth: "20%",
																		marginBottom: "2rem",
																	}}
																>
																	<Label
																		htmlFor="description"
																		className="form-label"
																	>
																		Description
																		<span>(Optional)</span>
																	</Label>
																	<Input
																		{...field}
																		id="description"
																		inputComponent="input"
																		variant="standard"
																		onBlur={handleBlure}
																		fullWidth
																	/>
																	{meta.touched && meta.error && (
																		<div
																			className="field-tip"
																			style={{
																				color: "red",
																			}}
																		>
																			{meta.error}
																		</div>
																	)}
																	<span className="field-tip">
																		With preserved line-breaks
																	</span>
																</div>
															)}
														</Field>
													</Col>
													{contractItem && contractItem?.type === "ERC1155" && (
														<Col md={6} xs={12}>
															<Field name="amount" type="text">
																{({ field, meta }) => (
																	<div
																		style={{
																			minWidth: "20%",
																			marginBottom: "2rem",
																		}}
																	>
																		<Label
																			htmlFor="amount"
																			className="form-label"
																		>
																			Amount
																		</Label>
																		<Input
																			{...field}
																			id="amount"
																			inputComponent="input"
																			variant="standard"
																			onBlur={handleBlure}
																			fullWidth
																		/>
																		{meta.touched && meta.error && (
																			<div
																				className="field-tip"
																				style={{
																					color: "red",
																				}}
																			>
																				{meta.error}
																			</div>
																		)}
																		<span></span>
																	</div>
																)}
															</Field>
														</Col>
													)}
													<Col md={6} xs={12}>
														<Field name="royalties" type="text">
															{({ field, meta }) => (
																<div
																	style={{
																		minWidth: "20%",
																		marginBottom: "2rem",
																	}}
																>
																	<Label
																		htmlFor="royalties"
																		className="form-label"
																	>
																		Royalties
																	</Label>
																	<Input
																		{...field}
																		id="royalties"
																		inputComponent="input"
																		variant="standard"
																		onBlur={handleBlure}
																		endAdornment={
																			<InputAdornment position="end">
																				%
																			</InputAdornment>
																		}
																		fullWidth
																	/>
																	{meta.touched && meta.error && (
																		<div
																			className="field-tip"
																			style={{
																				color: "red",
																			}}
																		>
																			{meta.error}
																		</div>
																	)}
																	<span className="field-tip">
																		Suggested: 0%, 10%, 20%, 30%
																	</span>
																</div>
															)}
														</Field>
													</Col>
												</Row>
												<LockableCreator
													account={account}
													previewData={previewData}
													ownPinata={ownPinata}
													setPreviewData={setPreviewData}
													lockableToIPFS={lockableToIPFS}
													setLockableToIPFS={setLockableToIPFS}
												/>
												{previewData?.attributes?.length > 0 && (
													<Typography
														className="form-label"
														style={{
															width: "100%",
															marginBottom: "1.5rem",
															fontFamily: "Montserrat",
															fontStyle: "normal",
															fontWeight: "bold",
															fontSize: "20px",
															lineHeight: "25px",
														}}
													>
														Metadata
													</Typography>
												)}
												<Box
													sx={{
														display: "flex",
														flexWrap: "wrap",
														marginBottom: "1.5rem",
													}}
												>
													<Box
														sx={{
															width: "100%",
														}}
													>
														<span className="form-label">
															Properties
															<span>(Optional)</span>
														</span>
														<Button
															variant="text"
															size="sm"
															color="primary"
															outline
															style={{
																marginLeft: "6px",
															}}
															onClick={() => handlAddButton()}
														>
															add
														</Button>
													</Box>
													{previewData?.attributes && (
														<CreateAtribute
															previewData={previewData}
															setPreviewData={setPreviewData}
														/>
													)}
												</Box>
												<Box
													sx={{
														display: "flex",
														justifyContent: "space-between",
													}}
												>
													<Button
														color="primary"
														onClick={() => setOpeActionnModal(true)}
													>
														Create item
													</Button>
												</Box>
											</Form>
										</Formik>
									</CardBody>
								</Card>
							</Col>

							<Col md={3} style={{ minWidth: "min-content" }}>
								{contractItem && previewData && (
									<PrewiewToken
										textMaxWidth="320px"
										previewData={previewData}
										contractType={contractItem.type}
										tempIsUploading={tempIsUploading}
										filePath={
											image.name
												? `${process.env.REACT_APP_API_DO_URL}/`
												: `${process.env.REACT_APP_IPFS_HOST}/`
										}
										fileType={image.type ? image.type : previewData.imageType}
										fileName={image.name ? image.name : previewData.image}
										cover={previewData.cover}
										lockableIsUploading={lockableIsUploading}
										openLockableModal={setShowLockablePreview}
									/>
								)}
							</Col>
						</>
					)}

					{isBatchMint && (
						<BatchMintComponent
							userId={_id}
							handleChange={handleChange}
							isBatchMint={isBatchMint}
							ownPinata={ownPinata}
							account={account}
							signer={signer}
							contractItem={contractItem}
							setShow={setShow}
							setStage={setStage}
							setError={setError}
							hideModal={hideModal}
						/>
					)}
				</Row>
			)}

			<MintModal
				isBatchMint={isBatchMint}
				show={show}
				stage={stage}
				error={error}
			/>

			<PreviewModal
				showPrev={showLockablePreview}
				closePrev={closePrev}
				type={
					lockable?.name
						? getFileTypeMime(lockable.type, lockable.name)
						: previewData?.digitalKey.type
				}
				target={
					lockable?.name
						? `${process.env.REACT_APP_API_DO_URL}/${lockable?.name}`
						: previewData?.digitalKey.value
				}
			/>
		</>
	);
}
